import { makeSubject, map, pipe, subscribe, take } from 'wonka';

export const isInIframe = (globalScope: Window = window) =>
  globalScope !== globalScope.top;

export const getSafeFrame = (() => {
  let safeFrameRegistered = false;
  // Create an event source that we can use to trigger callbacks when safeFrame is registered
  // instead of having to poll for it. Safe frame register spits out a lot of events over time
  // in future this can be used for listeners etc if we need to.
  const safeFrameEvent = makeSubject();

  /**
   * Check if safeFrame is registered and call the callback when it is.
   */
  const isRegistered = (callback = (registered: boolean) => {}) => {
    // if the safeFrameIsRegistered then we can immediately call the callback
    if (safeFrameRegistered) {
      callback(safeFrameRegistered);
      return;
    }

    // otherwise we need to wait for the event to fire and then call the callback
    pipe(
      safeFrameEvent.source,
      map(() => safeFrameRegistered),
      take(1), // we only need this to trigger once
      subscribe(callback),
    );
  };

  return (globalScope: Window = window) => {
    const safeFrame = globalScope.$sf;

    if (safeFrameRegistered || !safeFrame) {
      return { safeFrame, isRegistered };
    }

    const {
      self: { w, h },
    } = safeFrame.ext.geom();

    //  you *MUST* register otherwise calling safeFrame.ext.expand() silently does nothing.
    safeFrame.ext.register(+w, +h, (status, data) => {
      safeFrameRegistered = true;
      safeFrameEvent.next(safeFrameRegistered);
      console.log('debug ', status, data);
    });

    return {
      safeFrame,
      isRegistered,
    };
  };
})();
